import BasePlan from "./ic-basic.svg"
import PlanList from "./ic-list.svg"
import PlanCalendarCheck from "./ic-calendar-check.svg"
import PlanDocShare from "./ic-doc-link.svg"
import PlanChartShow from "./ic-chart-show.svg"

function ComponentBase() {
    return (
        <div className='w-80 flex-shrink-0 flex flex-col space-y-3 justify-center items-center lg:w-96'>
            <img className="h-10" src={BasePlan} alt="Professional Plan" />
            <h5 className="text-xl font-medium">Essential with Exceptional Value.</h5>
            {/* <h5 className="text-xl font-medium">15000DA</h5> */}
            <div className='w-full h-px rounded-full bg-secondary bg-opacity-30'></div>
            <div className="flex flex-col space-y-3" dir="rtl">
                <p className="text-lg text-center" dir="lrt">-</p>
                <div className="flex flex-row space-x-3 items-center">
                    <div className="flex-shrink-0 border-2 border-solid border-secondary rounded-xl w-14 h-14 flex justify-center items-center">
                        <img className="h-7 w-7" src={PlanList} alt="chat" />
                    </div>
                    <p className="text-lg content-center">إدارة كافة البيانات.</p>
                </div>
                <div className="flex flex-row space-x-3 items-center">
                    <div className="flex-shrink-0 border-2 border-solid border-secondary rounded-xl w-14 h-14 flex justify-center items-center">
                        <img className="h-7 w-7" src={PlanCalendarCheck} alt="graph" />
                    </div>
                    <p className="text-lg content-center">تحقق من الحصص القادمة في مكان واحد.</p>
                </div>
                <div className="flex flex-row space-x-3 items-center">
                    <div className="flex-shrink-0 border-2 border-solid border-secondary rounded-xl w-14 h-14 flex justify-center items-center">
                        <img className="h-7 w-7" src={PlanDocShare} alt="save" />
                    </div>
                    <p className="text-lg content-center">استخراج سجل حضور الحصة بنقرة واحدة.</p>
                </div>
                <div className="flex flex-row space-x-3 items-center">
                    <div className="flex-shrink-0 border-2 border-solid border-secondary rounded-xl w-14 h-14 flex justify-center items-center">
                        <img className="h-7 w-7" src={PlanChartShow} alt="doc search" />
                    </div>
                    <p className="text-lg content-center">احصل على نظرة عامة على الأداء.</p>
                </div>
            </div>
        </div>
    );
}

export default ComponentBase;